/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";

/* Data Imports */
import AppConfig from "../../../AppConfig";
import internationalPhoneCodesUnicode from "../../../lib/data/international-phone-codes-unicode.json";

/* Icon Imports */
// import defaultFlag from "../../../public/images/icons/country-flags/in.svg";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 4rem)",
    width: "100%",
  },
  contactPaper: {
    padding: "1rem 1rem 1rem 1rem",
    width: "45%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  contactForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "space-between",
    width: "100%",
  },
  textField: {
    margin: "0rem 0rem 1.5rem 0rem",
    width: "100%",
  },
  nameField: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "2rem",
    justifyContent: "space-between",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: "0rem",
    },
  },
  checkboxRow: {
    padding: "0rem 0rem 1rem 0.5rem",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.up("lg")]: {
      alignItems: "center",
    },
  },
  heading: {
    color: "#0FCA56",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "0rem 0rem 1rem 0rem",
  },
  greyp: {
    color: "#666666",
  },
  dialogActions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  otpButton: {
    margin: "1rem 0rem 0rem 0rem",
    background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    color: "#FFFFFF",
    borderRadius: "0rem",
    borderWidth: "0px",
    boxShadow: "none",
    width: "100%",
    padding: "0.65rem 1rem",
    "&:hover": {
      background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
      color: "#FFFFFF",
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      boxShadow: "none",
    },
  },
  helpText: {
    margin: "0.5rem 0rem 1rem 0rem",
  },
  autocomplete: {
    margin: "0rem 0rem 1.5rem 0rem",
    width: "100%",
  },
  li: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SignUpForm = (props) => {
  const classes = useStyles();

  const [loadingSnackbar, setLoadingSnackbar] = React.useState(false);
  const [successSnackbar, setSuccessSnackbar] = React.useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] =
    React.useState("Success!");
  const [errorSnackbar, setErrorSnackbar] = React.useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = React.useState(
    "Oops! Something went wrong. Please try again."
  );
  const [otp, setOtp] = React.useState("");
  const [fname, setFName] = React.useState("");
  const [lname, setLName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [atc, setAtc] = React.useState(false);

  const [showOtpField, setShowOtpField] = React.useState(false);
  const [otpFieldDisabled, setOtpFieldDisabled] = React.useState(true);
  const [otpBtnDisabled, setOtpBtnDisabled] = React.useState(true);
  const [countryCode, setCountryCode] = React.useState(
    (
      internationalPhoneCodesUnicode.find((country) => country.code === "IN") ||
      internationalPhoneCodesUnicode[100]
    ).dial_code
  );
  // const [countryFlag, setCountryFlag] = React.useState(
  //   <SvgIcon component={defaultFlag} viewBox="0 0 24 24" />
  // );

  React.useEffect(() => {
    checkBtnDisabled();
  }, [fname, lname, email, phone, atc]);

  const checkBtnDisabled = () => {
    if (
      fname !== "" &&
      lname !== "" &&
      phone !== "" &&
      /* !phone.match(/^[6-9]\d{9}$/) && */
      email !== "" &&
      email.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+.+[a-zA-Z]$/) &&
      atc == true
    ) {
      setOtpBtnDisabled(false);
    } else if (
      fname == "" ||
      lname == "" ||
      phone == "" ||
      /* !phone.match(/^[6-9]\d{9}$/) || */
      email == "" ||
      !email.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+.+[a-zA-Z]$/) ||
      atc == false
    ) {
      setOtpBtnDisabled(true);
    }
  };

  /* useEffect that will update the country flag in the TextField */

  // React.useEffect(() => {
  //   import(
  //     "../../../public/images/icons/country-flags/" +
  //       (
  //         internationalPhoneCodesUnicode.find(
  //           (country) => country.dial_code === countryCode
  //         ) || internationalPhoneCodesUnicode[100]
  //       ).code.toLowerCase() +
  //       ".svg"
  //   )
  //     .then((flag) => {
  //       setCountryFlag(
  //         <SvgIcon
  //           component={flag.default}
  //           // inheritViewBox={flag.default().props.viewBox ? true : false}
  //           viewBox={
  //             "0 0 " +
  //             flag.default().props.width +
  //             " " +
  //             flag.default().props.height
  //           }
  //         />
  //       );
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setCountryFlag(defaultFlag);
  //     });
  // }, [countryCode]);

  /* Handle onChange Country Code */
  const onChangeCountryCode = (event, value, reason) => {
    setCountryCode(
      value === null
        ? internationalPhoneCodesUnicode[100].dial_code
        : value.dial_code
    );
  };

  /* Get OTP Button */
  const getOtp = () => {
    setLoadingSnackbar(true);
    fetch(
      AppConfig.apiUrlPrefix +
        "authentication/send-otp?phone=" +
        encodeURIComponent(countryCode + phone) +
        "&channel=sms",
      { cache: "no-store" }
    )
      .then((res) => res.json())
      .then((j) => {
        if (j.error == false) {
          setLoadingSnackbar(false);
          setSuccessSnackbarMessage("OTP sent successfully!");
          setSuccessSnackbar(true);
          setOtp("");
          setOtpFieldDisabled(false);
          setShowOtpField(true);
        } else {
          setLoadingSnackbar(false);
          setErrorSnackbarMessage(
            "Oops! Something went wrong. Please try again."
          );
          setErrorSnackbar(true);
          setShowOtpField(false);
        }
        if (typeof submitCallback === "function") submitCallback(j);
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setErrorSnackbarMessage(
          "Oops! Something went wrong. Please try again."
        );
        setErrorSnackbar(true);
        setShowOtpField(false);
        if (typeof submitCallback === "function") submitCallback(error);
        /* TODO: Send Slack message with error */
      });
  };

  /* Submit OTP Button */
  const submitOtp = () => {
    setLoadingSnackbar(true);
    setOtpFieldDisabled(true);
    setOtpBtnDisabled(true);
    fetch(
      AppConfig.apiUrlPrefix +
        "authentication/verify-otp?phone=" +
        encodeURIComponent(countryCode + phone) +
        "&code=" +
        encodeURIComponent(otp) +
        "&channel=sms",
      { cache: "no-store" }
    )
      .then((res) => res.json())
      .then((j) => {
        if (j.status === "approved") {
          setLoadingSnackbar(false);
          setSuccessSnackbarMessage("OTP verified successfully!");
          setSuccessSnackbar(true);
          submitForm();
        } else {
          setLoadingSnackbar(false);
          setOtp("");
          setOtpFieldDisabled(false);
          setOtpBtnDisabled(false);
          setErrorSnackbarMessage("Oops! OTP is invalid please try again !");
          setErrorSnackbar(true);
        }
        if (typeof submitCallback === "function") submitCallback(j);
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setOtp("");
        setOtpFieldDisabled(false);
        setOtpBtnDisabled(false);
        setErrorSnackbarMessage(
          "Oops! Something went wrong. Please try again."
        );
        setErrorSnackbar(true);
        if (typeof submitCallback === "function") submitCallback(error);
        /* TODO: Send Slack message with error */
      });
  };

  /* Sign Up Button */
  const submitForm = () => {
    const reqURL =
      AppConfig.apiUrlPrefix +
      "authentication/user-sign-up?firstname=" +
      fname +
      "&lastname=" +
      lname +
      "&phone=" +
      encodeURIComponent(countryCode + phone) +
      "&email_address=" +
      encodeURIComponent(email) +
      "&verified=" +
      false +
      "&agree=" +
      atc;
    setOtpBtnDisabled(true);
    setLoadingSnackbar(true);
    fetch(reqURL, { cache: "no-store" })
      .then((res) => {
        res
          .json()
          .then((data) => {
            console.log("submit", data);
            if (data.status == "success") {
              setLoadingSnackbar(false);
              setSuccessSnackbarMessage("Signed Up Successfully!");
              setSuccessSnackbar(true);
              setTimeout(() => {
                window.location = "/sign-in";
              }, 1000);
            } else if (data.status == "error") {
              setLoadingSnackbar(false);
              setErrorSnackbarMessage(data.error);
              setErrorSnackbar(true);
            }
            if (typeof submitCallback === "function") submitCallback(data);
            /* TODO: Send Slack message with lead */
          })
          .catch((error) => {
            console.log(error);
            setLoadingSnackbar(false);
            setErrorSnackbarMessage(error.error);
            setErrorSnackbar(true);
            if (typeof submitCallback === "function") submitCallback(error);
            /* TODO: Send Slack message with error */
          });
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setErrorSnackbarMessage(
          "Oops! Something went wrong. Please try again."
        );
        setErrorSnackbar(true);
        if (typeof submitCallback === "function") submitCallback(error);
        /* TODO: Send Slack message with error */
      });
  };

  const handleLoadingSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLoadingSnackbar(false);
  };
  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbar(false);
  };

  return (
    <React.Fragment>
      <Snackbar
        open={loadingSnackbar}
        autoHideDuration={3000}
        onClose={handleLoadingSnackbarClose}
      >
        <Alert onClose={handleLoadingSnackbarClose} severity="info">
          Sending information...
        </Alert>
      </Snackbar>
      <Snackbar
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={handleSuccessSnackbarClose}
      >
        <Alert onClose={handleSuccessSnackbarClose} severity="success">
          {successSnackbarMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={3000}
        onClose={handleErrorSnackbarClose}
      >
        <Alert onClose={handleErrorSnackbarClose} severity="error">
          {errorSnackbarMessage}
        </Alert>
      </Snackbar>

      <div className={classes.sectionContainer}>
        <Paper elevation={3} className={classes.contactPaper}>
          <form id="cf" className={classes.contactForm} method="GET">
            <Typography variant="h4" className={classes.heading}>
              Sign up
            </Typography>
            <DialogContent dividers>
              <div className={classes.nameField}>
                <TextField
                  id="fname"
                  name="fname"
                  label="First Name"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setFName(event.target.value);
                  }}
                  disabled={showOtpField}
                />
                <TextField
                  id="lname"
                  name="lname"
                  label="Last Name"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setLName(event.target.value);
                  }}
                  disabled={showOtpField}
                />
              </div>
              <TextField
                id="email"
                name="email"
                label="Email"
                required={true}
                type="text"
                className={classes.textField}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                disabled={showOtpField}
              />

              {/* Country Code */}
              <div className={classes.nameField}>
                <Autocomplete
                  className={classes.autocomplete}
                  options={internationalPhoneCodesUnicode}
                  autoHighlight={true}
                  getOptionLabel={(option) =>
                    option.code + " " + option.dial_code
                  }
                  defaultValue={internationalPhoneCodesUnicode.find(
                    (country) => country.dial_code === "+91"
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      <li className={classes.li}>
                        <img
                          src={option.svg}
                          alt={option.name}
                          width={24}
                          height={24}
                          loading="lazy"
                        />
                        <Typography
                          variant="body2"
                          component="span"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 400,
                            lineHeight: "1.5rem",
                          }}
                        >
                          {option.name + " " + option.dial_code}
                        </Typography>
                      </li>
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required={true}
                      label="Country Code"
                      type="text"
                      name="internationalPhoneCode"
                      id="internationalPhoneCode"
                      sx={{
                        width: "100%",
                        margin: "0rem 0rem 1rem 0rem",
                        flex: "0.5",
                      }}
                      disabled={showOtpField}
                      placeholder="India +91"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                      // InputProps={{
                      //   ...params.InputProps,
                      //   startAdornment: (
                      //     <React.Fragment>
                      //       <InputAdornment position="start">
                      //         {countryFlag}
                      //       </InputAdornment>
                      //       {params.InputProps.startAdornment}
                      //     </React.Fragment>
                      //   ),
                      // }}
                    />
                  )}
                  filterOptions={createFilterOptions({
                    stringify: (option) =>
                      option.code +
                      option.dial_code +
                      option.name +
                      option.flag,
                  })}
                  onChange={onChangeCountryCode}
                  // autoSelect={true}
                  disableClearable={true}
                  disabled={showOtpField}
                />
                <TextField
                  id="phone"
                  name="phone"
                  label="Phone Number"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setPhone(event.target.value);
                  }}
                  disabled={showOtpField}
                />
              </div>
              {showOtpField ? (
                <TextField
                  id="otp"
                  name="otp"
                  label="One Time Password (OTP)"
                  className={classes.textField}
                  onChange={(event) => {
                    setOtp(event.target.value);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      submitOtp();
                    }
                  }}
                  value={otp}
                  disabled={otpFieldDisabled}
                />
              ) : (
                <span />
              )}
              <div className={classes.checkboxRow}>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ padding: "0rem 0.5rem 0rem 0rem" }}
                      checked={atc}
                      onChange={(event) => {
                        setAtc(!atc);
                      }}
                      color="primary"
                      name="agree"
                      disabled={showOtpField}
                    />
                  }
                  label={
                    <span>
                      <span className={classes.greyp}>
                        I have read and agree with the{" "}
                      </span>
                      <Link
                        href="/terms"
                        aria-label="Terms of Service"
                        title="Terms of Service"
                        rel="noopener"
                      >
                        Terms of Service{" "}
                      </Link>
                      and{" "}
                      <Link
                        href="/privacy"
                        aria-label="Privacy Policy"
                        title="Privacy Policy"
                        rel="noopener"
                      >
                        Privacy Policy
                      </Link>
                    </span>
                  }
                />
              </div>
            </DialogContent>

            <DialogActions className={classes.dialogActions}>
              <span className={classes.helpText}>
                <span className={classes.greyp}>Already have an account? </span>
                <Link
                  href="/sign-in"
                  aria-label="Sign in"
                  title="Sign in"
                  rel="noopener"
                >
                  Sign in
                </Link>
              </span>
              {showOtpField ? (
                <Button
                  variant="contained"
                  title="Submit OTP"
                  onClick={submitOtp}
                  disabled={otpBtnDisabled}
                  rel="noopener"
                  className={classes.otpButton}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  variant="contained"
                  title="Get OTP"
                  onClick={getOtp}
                  disabled={otpBtnDisabled}
                  rel="noopener"
                  className={classes.otpButton}
                >
                  Get OTP
                </Button>
              )}
            </DialogActions>
          </form>
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default SignUpForm;
